"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _appActions = require("../appActions");
var _questionnaireActions = require("./questionnaireActions");
var _recommendationActions = require("../recommendation/recommendationActions");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var initialState = {
  questions: [],
  currentQuestionIndex: 0,
  selections: {},
  answers: [],
  handsetSearchList: [],
  budget: {},
  isBudgetAdjusted: false
};
var questionnaireReducer = function questionnaireReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case _questionnaireActions.SET_QUESTIONS:
      return _objectSpread(_objectSpread({}, state), {}, {
        questions: payload.questions
      });
    case _questionnaireActions.GOTO_NEXT_QUESTION:
      {
        var currentQuestionIndex = state.currentQuestionIndex;
        var answer = {
          questionIndex: currentQuestionIndex,
          metadata: payload.metadata,
          summary: payload.summary
        };
        return _objectSpread(_objectSpread({}, state), {}, {
          currentQuestionIndex: payload.nextQuestionIndex,
          answers: [].concat(_toConsumableArray(state.answers), [answer])
        });
      }
    case _questionnaireActions.GOTO_PREVIOUS_QUESTION:
    case _recommendationActions.GO_BACK_TO_QUESTIONNAIRE:
      {
        var answers = state.answers;
        var previousAnswer = answers[answers.length - 1];
        var previousQuestionIndex = previousAnswer.questionIndex;
        return _objectSpread(_objectSpread({}, state), {}, {
          currentQuestionIndex: previousQuestionIndex,
          answers: answers.slice(0, -1)
        });
      }
    case _questionnaireActions.GOTO_QUESTION:
      {
        var questionIndex = state.questions.findIndex(function (question) {
          return question.id === payload.id;
        });
        var _answers = state.answers.slice(0, state.answers.findIndex(function (answer) {
          return answer.questionIndex === questionIndex;
        }));
        return _objectSpread(_objectSpread({}, state), {}, {
          currentQuestionIndex: questionIndex,
          answers: _answers
        });
      }
    case _questionnaireActions.VIEW_QUESTION:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          viewQuestionIndex: payload.viewQuestionIndex
        });
      }
    case _questionnaireActions.SKIP_QUESTION:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentQuestionIndex: payload.nextQuestionIndex
      });
    case _questionnaireActions.RESET_QUESTIONNAIRE:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentQuestionIndex: 0,
        selections: {},
        answers: [],
        budget: []
      });
    case _questionnaireActions.ADD_SELECTION:
      {
        var selections = state.selections,
          _currentQuestionIndex = state.currentQuestionIndex;
        if (!selections[_currentQuestionIndex]) {
          selections[_currentQuestionIndex] = [];
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          selections: _objectSpread(_objectSpread({}, selections), {}, _defineProperty({}, _currentQuestionIndex, [].concat(_toConsumableArray(selections[_currentQuestionIndex]), [payload.selection])))
        });
      }
    case _questionnaireActions.REMOVE_SELECTION:
      {
        var _currentQuestionIndex2 = state.currentQuestionIndex,
          _selections = state.selections;
        return _objectSpread(_objectSpread({}, state), {}, {
          selections: _objectSpread(_objectSpread({}, _selections), {}, _defineProperty({}, _currentQuestionIndex2, _selections[_currentQuestionIndex2].filter(function (selection) {
            return selection !== payload.selection;
          })))
        });
      }
    case _questionnaireActions.REPLACE_SELECTION:
      {
        var _currentQuestionIndex3 = state.currentQuestionIndex,
          _selections2 = state.selections;
        var currentSelections = _selections2[_currentQuestionIndex3];
        return _objectSpread(_objectSpread({}, state), {}, {
          selections: _objectSpread(_objectSpread({}, _selections2), {}, _defineProperty({}, _currentQuestionIndex3, Object.assign([], currentSelections, _defineProperty({}, payload.index, payload.selection))))
        });
      }
    case _questionnaireActions.RESET_SELECTIONS:
      {
        var _currentQuestionIndex4 = state.currentQuestionIndex,
          _selections3 = state.selections;
        return _objectSpread(_objectSpread({}, state), {}, {
          selections: _objectSpread(_objectSpread({}, _selections3), {}, _defineProperty({}, _currentQuestionIndex4, []))
        });
      }
    case _appActions.INJECT_STATE:
      return _objectSpread(_objectSpread({}, state), payload.questionnaire);
    case _questionnaireActions.SET_HANDSET_SEARCH_LIST:
      return _objectSpread(_objectSpread({}, state), {}, {
        handsetSearchList: payload.handsetList
      });
    case _questionnaireActions.SET_BUDGET:
      return _objectSpread(_objectSpread({}, state), {}, {
        budget: payload.budget
      });
    case _questionnaireActions.RESET_BUDGET_AND_RECOMMENDATION:
      return _objectSpread(_objectSpread({}, state), {}, {
        budget: {},
        isBudgetAdjusted: false
      });
    case _questionnaireActions.ADJUST_BUDGET:
      return _objectSpread(_objectSpread({}, state), {}, {
        isBudgetAdjusted: payload.budgetAdjusted
      });
    default:
      return state;
  }
};
var _default = questionnaireReducer;
exports.default = _default;